import { useEffect, useRef } from 'react';
import { subscribeToMessages } from '../services/chatRealtime';
import { ChatMessage } from '../types/chat';

/**
 * Listens for incoming messages on the app's shared realtime channel.
 * `onResync` fires after the connection was dropped (hidden tab) and restored.
 */
export function useMessagesRealtime(
  enabled: boolean,
  onInsert: (message: ChatMessage) => void,
  onResync?: () => void
) {
  const insertRef = useRef(onInsert);
  insertRef.current = onInsert;
  const resyncRef = useRef(onResync);
  resyncRef.current = onResync;

  useEffect(() => {
    if (!enabled) return;
    return subscribeToMessages(
      message => insertRef.current(message),
      () => resyncRef.current?.()
    );
  }, [enabled]);
}
